import React, { memo } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'transfix-ui/components/Button'
import { ReactComponent as DriverEmptyIllustration } from 'apps/fleet-planner/components/illustrations/onboarding/DriverEmpty.svg'
import { IDriver } from 'apps/fleet-planner/types'

export const DriversEmpty = memo<{ driver?: IDriver }>(() => {
  const history = useHistory()
  const addLoadClickHandler = () => history.push(`${history.location.pathname}/create-load`)
  return (
    <div className='calendar-view-empty-column'>
      <DriverEmptyIllustration />
      <div className='text-secondary body-medium mt6'>You haven&apos;t added any drivers yet</div>
      <div className='mt6'>
        <span className='text-secondary'>To add a driver,</span>
        <span className='ml1'>
          <Button
            className='btn-text-link-b'
            onClick={addLoadClickHandler}
            data-test='loads-list-no-load-clear-all-filters-btn'>
            add a load and assign a driver
          </Button>
        </span>
      </div>
    </div>
  )
})
